<template>
  <li
    class="product"
    :class="{ active: active, unselectable: !selectable, disabled: disabled }"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @mousemove="handleMouseMove"
  >
    <div class="img-holder">
      <inline-svg
        v-if="isDefaultIcon"
        class="product-icon"
        :src="'/images/product-icons/' + product.image"
      />
      <img v-else :src="'/images/product-icons/' + product.image" />
      <div v-if="product.securityLevel > 0" class="secured-badge">
        <inline-svg
          class="secured-icon"
          src="/images/product-icons/secured-lock-icon.svg"
        />
        <span class="secured-label">Secured printen</span>
      </div>
    </div>
    <div class="text-holder">
      <span>{{ product.title }}</span>
    </div>
    <teleport to="body">
      <span
        v-if="showTooltip"
        class="disabled-tooltip"
        :style="{ left: tooltipX + 'px', top: tooltipY + 'px' }"
      >
        {{ disabledReason }}
      </span>
    </teleport>
  </li>
</template>

<script>
export default {
  props: ['product', 'active', 'selectable', 'disabled', 'disabledReason'],
  data() {
    return {
      showTooltip: false,
      tooltipX: 0,
      tooltipY: 0
    }
  },
  computed: {
    isDefaultIcon() {
      return this.product.image?.startsWith('default/')
    }
  },
  watch: {
    // Hide the tooltip when the product becomes selectable again while hovering
    disabled(isDisabled) {
      if (!isDisabled) {
        this.showTooltip = false
      }
    }
  },
  methods: {
    handleMouseEnter(event) {
      if (!this.disabled || !this.disabledReason) return

      this.showTooltip = true
      this.updateTooltipPosition(event)
    },
    handleMouseLeave() {
      this.showTooltip = false
    },
    handleMouseMove(event) {
      if (this.showTooltip) {
        this.updateTooltipPosition(event)
      }
    },
    updateTooltipPosition(event) {
      this.tooltipX = event.clientX + 10
      this.tooltipY = event.clientY + 10
    }
  }
}
</script>

<style lang="scss" scoped>
.product {
  cursor: pointer;
  box-shadow: var(--default-shadow);
  width: 146px;
  border-radius: 24px;
  padding: 4px;
  margin: 10px 12px;
  transition: box-shadow 0.5s;

  &:hover {
    box-shadow: var(--default-shadow-hover);
  }

  &.active {
    .text-holder {
      background-color: var(--selected-color);
    }
  }

  &.unselectable {
    cursor: default;
    box-shadow: var(--default-shadow);
  }

  &.disabled {
    cursor: default;
    opacity: 0.45;
    filter: grayscale(100%);

    &:hover {
      box-shadow: var(--default-shadow);
    }
  }
}

// Teleported to body, positioned next to the cursor
.disabled-tooltip {
  position: fixed;
  max-width: 200px;
  padding: 8px 12px;
  background-color: #333;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.3;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  pointer-events: none;
}

.img-holder {
  height: 126px;
  padding: 23px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  img,
  .product-icon {
    width: 100%;
    height: 100%;
  }

  .product-icon {
    :deep([fill='#002169']),
    :deep([fill='#00226D']) {
      fill: var(--icon-color);
    }

    :deep([stroke='#002169']),
    :deep([stroke='#00226D']) {
      stroke: var(--icon-color);
    }
  }

  .secured-badge {
    position: absolute;
    top: 8px;
    right: 8px;

    &:hover .secured-label {
      opacity: 1;
    }
  }

  .secured-icon {
    width: 13px;
    height: 17px;
    flex-shrink: 0;

    :deep([fill='#002169']),
    :deep([fill='#00226D']),
    :deep(.st0) {
      fill: var(--icon-color);
    }

    :deep([stroke='#002169']),
    :deep([stroke='#00226D']),
    :deep(.st1) {
      stroke: var(--icon-color);
    }
  }

  .secured-label {
    position: absolute;
    top: calc(100% - 34px);
    right: -80px;
    font-size: 10px;
    font-weight: 600;
    color: white;
    white-space: nowrap;
    background: var(--icon-color);
    border-radius: 10px;
    padding: 2px 7px;
    opacity: 0;
    transition: opacity 0.2s;
  }
}

.text-holder {
  text-align: center;
  background: #f4f4f4;
  border-radius: 20px;
  //font-size: 12px;
  font-weight: 600;
  padding: 7px;
  height: 62px;
  display: flex;
  align-items: center;
  transition: all 0.4s;

  span {
    width: 100%;
  }
}
</style>
